export { renderLink_unstable as renderLink } from '@fluentui/react-link';
